import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/** idiomas soportados */
const LANGS = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
];

export default function LanguageSwitch() {
  const { i18n } = useTranslation<'translation'>();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const open = (e: React.MouseEvent<HTMLElement>) => setAnchor(e.currentTarget);
  const close = () => setAnchor(null);

  const change = (lng: string) => {
    i18n.changeLanguage(lng);
    close();
  };

  const { t } = useTranslation<'translation'>();

  return (
    <>
      <Tooltip title={t('languageSwitch.tooltip')}>
        <IconButton size="small" sx={{ ml: 1 }} onClick={open}>
          <LanguageIcon />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        {LANGS.map((l) => (
          <MenuItem
            key={l.code}
            selected={i18n.language.startsWith(l.code)}
            onClick={() => change(l.code)}
          >
            {l.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
